import loadable from '@loadable/component';
import Loading from '../../components/Loader';

const DoeGate = loadable(() => import(/* webpackChunkName: "doe-home" */ '../../pages/Doe'), {
  fallback: Loading,
});

export default DoeGate;
